export enum ActionTypes {
  COLLAPSE = 'COLLAPSE',
  OPEN = 'OPEN',
  UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB',
  SAVE_VIEWS = 'SAVE_VIEWS'
}
